module.exports = __webpack_public_path__ + "img/10.fc5488b3.jpg";